import axios from 'axios';
import store from 'store';

export const HTTP = axios.create({
  baseURL: process.env.BASE_URL,
})

export const HTTPAUTH = axios.create({
	baseURL: process.env.BASE_URL,
	headers: {
    	'Authorization': store.get('topographicalapp-token')
    }
})




// WEBPACK FOOTER //
// ./src/utils/http-base.js